import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TedTheme from '@common/providers/ThemeProvider/TedTheme';
import MyButton from '@common/components/Button/MyButton';

import { TextField } from '@mui/material';

import styles from './LoginPage.module.scss';
import { useAuthStore } from '@store/authStore';

const LoginInput = ({ value, placeholder, onChange, ...rest }) => {
  return (
    <TextField
      type='text'
      placeholder={placeholder}
      value={value}
      variant='filled'
      autoComplete='off'
      onChange={onChange}
      required
      {...rest}
      sx={{ width: '100%', py: 1 }}
    />
  );
};

const LoginForm = () => {
  const { login, colorMode } = useAuthStore();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const newPath = await login({
        username,
        password,
      });

      navigate(newPath);
    } catch (err) {
      console.log('err: ', err);
      setError('Invalid credentials');
    }
  };

  return (
    <div className={styles.loginContainer}>
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <h2
          className={styles.loginHeader}
          style={{ color: colorMode === 'light' ? 'black' : 'white' }}
        >
          Login
        </h2>
        <LoginInput
          placeholder='User name *'
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <LoginInput
          type='password'
          placeholder='Password *'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <MyButton
          sx={{
            width: '100%',
            height: '3rem',
            marginTop: '1.1rem',
            marginBottom: '3px',
            textTransform: 'uppercase',
            fontWeight: '400',
          }}
          type='submit'
        >
          Log in
        </MyButton>
        {error && <p className={styles.error}>{error}</p>}
      </form>
    </div>
  );
};

const LoginPage = () => {
  return (
    <TedTheme>
      <LoginForm />
    </TedTheme>
  );
};

export default LoginPage;
